module.exports = __webpack_public_path__ + "img/dashboard.95103168.svg";